<template>
    <div>
        <!-- 图片 -->
        <div class="bg">
            <div class="sub-title">Products</div>
            <!-- <div class="title">产品中心</div> -->
        </div>
        <div class="m-3">
            <!-- 控制器 -->
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">Controller</div>
                        <!-- <div class="title">控制器</div> -->
                    </div>
                    <!-- <div>
                        <img src="@/assets/mimg/arrow.png" alt="" style="width: 50px;">
                    </div> -->
                </div>
                <div class="mt-1 flex-row flex-wrap justify-between">
                    <div  class="product-item" v-for="(item,index) in controllerData">
                        <div class="product-img flex-row align-center justify-center">
                            <img :ref="prefix+item.id" :src="http.ipAddress+item.filePath" style="width: 100px;height: 100px;" alt=""  @click="page(item.id)">
                        </div>
                        <div class="text-center mt-1 ">{{item.productNameEN}}</div>
                    </div>
                </div>
            </div>
            <!-- 智能仪表 -->
            <div class="mt-3">
                <div class="flex-row justify-between align-center">
                    <div>
                        <div class="sub-title">Meter</div>
                        <!-- <div class="title">智能仪表</div> -->
                    </div>
                    <!-- <div>
                        <img src="@/assets/mimg/arrow.png" alt="" style="width: 50px;">
                    </div> -->
                </div>
                <div class="mt-1 flex-row flex-wrap justify-between">
                    <div  class="product-item" v-for="(item,index) in meterData">
                        <div class="product-img flex-row align-center justify-center">
                            <img :ref="prefix+item.id" :src="http.ipAddress+item.filePath" style="width:100px;height: 100px;" alt="" @click="page1(item.id)">
                        </div>
                        <div class="text-center mt-1 ">{{item.productNameEN}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            // controllerData:controllerData,
            // meterData:meterData,
            prefix:"product",
            controllerData:[],
            meterData:[],
            keepScroll: 0
        }
    },
    methods: {
        page(index) {
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
            this.keepScroll = scrollTop;
            this.$router.push({path:'/productsDetail', query: {switch:1,index}});
        },
        page1(index) {
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
            this.keepScroll = scrollTop;
            this.$router.push({path:'/productsDetail', query: {switch:2,index}});
        }
    },
    activated() {
      var gotoScroll = this.keepScroll
      setTimeout(function(){
          //兼容 PC and Mobile 写两个
          document.body.scrollTop = gotoScroll;
          document.documentElement.scrollTop = gotoScroll;
          console.debug('set:' + gotoScroll)
      }, 10);
    },
    mounted() {
        debugger
        let that=this;
        this.http.post("/api/FJ_ProductInfo/GetAllProduct",JSON.stringify({})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
                for(let i=0;i<objResult.data.length;i++){
                    if(objResult.data[i].productType==1){
                        that.controllerData.push(objResult.data[i]);
                    }
                    else if(objResult.data[i].productType==2){
                        that.meterData.push(objResult.data[i]);
                    }
                }
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });
    }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px; 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.m-3 {
    margin: 30px;
}

.video {
    background-color: #00585252;
    height: 200px;
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
}

.mt-3 {
    margin-top: 30px;
}

.content {
    margin-top: 10px;
    text-indent: 2rem;
}

.product-item {
    width: 48%;
    margin-bottom: 10px;
    border: 1px solid #ffffff
}

.border {
    border-top: 1px solid #eee;
    padding: 5px 0;
}

.product-img {
    background-color: #eee;
    width: 100%;
    height: 100px;
}

.customer-item {
    height: 100px;
    margin-bottom: 10px;
}

.customer-left {
    border-bottom: 1px dashed #0AA00A;
    width: 65%;
}

.customer-right {
    width: 30%;
    background-color: #0AA00A;
    color: #fff;
}

.project-item {
    width: 50%;
    margin-bottom: 30px;
}

.input {
    border-radius: 10px;
    padding: 5px;
    width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/views/products/m_index.vue